import React from 'react';
import './App.css';
import Header from './components/Header';
// import Navigation from './components/Navigation';
import Hero from './components/Hero';
import Bio from './components/Bio';
import SocialMedia from './components/SocialMedia';
import Support from './components/Support';
import MusicSection from './components/MusicSection';
import Gallery from './components/Gallery';
import Agenda from './components/Agenda';
import Footer from './components/Footer';

function App() {

  return (
    <div className="App">
      <Header />
      <Hero />
      <Bio />
      <SocialMedia />
      <Support />
      {/* Singles Section */}
      <div id="singles">
        <MusicSection
          title="SINGLES & REMIXES"
          type="singles"
          tracks={[
            { id: 2, title: 'Single 1', spotifyId: '2latLiiBuXaM5Jb7Eane41', height: '352' },
            { id: 3, title: 'Single 2', spotifyId: '0oJi6hsAtWLUWqAjL6pxkz', height: '352' }
          ]}
        />
      </div>

      <Gallery />
      <Agenda />
      <Footer />
    </div>
  );
}

export default App;
